// eslint-disable-next-line import/prefer-default-export
export const SERVICE_TYPE_DICT = {
  SUPPLEMENTING_MATERIALS: 'supplementing_materials',
  FLEET_SERVICE: 'fleet_service',
  LOCOMOTIVE_WASHING: 'locomotive_washing',
  REVIEW_P1: 'review_p1',
  REVIEW_P2: 'review_p2',
  REVIEW_P3: 'review_p3',
  TRAIN_CLEANING: 'train_cleaning',
  CARGO_CORRECTION: 'cargo_correction',
};

export const REPLY_DICT = {
  DECLINE: 0,
  ACCEPT: 1,
};
